import { PriceDataWrapper } from "./styles"
import { Grid } from "@mui/material"
import { CustomDivider, HeaderSection } from "../reservationInfo/styles"
import { useTranslation } from "react-i18next"
import { FORM_REGEX_VALIDATORS } from "@utils"
import Input from "@Common/input"
import MoneysIcon from "@assets/svg/MoneysIcon.svg?react"

// MS-589 — this tab no longer derives `totalPrice`. It used to, from a prop memoised on the API
// response that still held the check-out the reservation was LOADED with, so lengthening a stay
// left the total where it was; and it only ran at all once the host opened this tab, so a host
// who edited the dates and saved from the first tab submitted the loaded price either way. The
// derivation now lives in the form that owns every one of those fields.
export default function PriceData() {
	const { t } = useTranslation()
	return (
		<PriceDataWrapper>
			<div>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<HeaderSection>
							<MoneysIcon />
							<p>{t("COMMON.BOOKING_PRICE_DATA")}</p>
						</HeaderSection>
					</Grid>
					<Grid item xs={12} md={6}>
						<Input
							name='nightPrice'
							label={t("MANUALRESERVATION.NIGHTPRICE")}
							placeholder={t("MANUALRESERVATION.NIGHTPRICE")}
							registerOptions={{
								required: {
									value: true,
									message: t("MANUALRESERVATION.PLEASEENTERTHENIGHTRATE"),
								},
								pattern: {
									value: FORM_REGEX_VALIDATORS.digitsDecimal,
									message: t(
										"MANUALRESERVATION.ONLYNUMBERSAREALLOWEDINTHISFIELD"
									),
								},
							}}
						/>
					</Grid>
					<Grid item xs={12}></Grid>
					<Grid item xs={12} md={6}>
						<Input
							name='totalPrice'
							label={t("MANUALRESERVATION.TOTALPRICEOFRESERVATION")}
							placeholder={t("MANUALRESERVATION.TOTALPRICEOFRESERVATION")}
							readonly
							registerOptions={{
								required: {
									value: true,
									message: t("MANUALRESERVATION.PLEASEENTERTHETOTALPRICE"),
								},
								pattern: {
									value: FORM_REGEX_VALIDATORS.digitsDecimal,
									message: t(
										"MANUALRESERVATION.ONLYNUMBERSAREALLOWEDINTHISFIELD"
									),
								},
							}}
						/>
					</Grid>
					<CustomDivider />
				</Grid>
			</div>
		</PriceDataWrapper>
	)
}
